import { lazy, Suspense, useMemo, useState } from "react";
import AnimatedCounter from "@/components/AnimatedCounter";
import Reveal from "@/components/landing/Reveal";
import LocationsCarousel from "@/components/landing/LocationsCarousel";
import { renderTitle } from "@/components/landing/utils";

const LocationsMap = lazy(() => import("@/components/landing/LocationsMap"));

export default function LocationsSection({ block }) {
  const items = useMemo(() => (block?.items || [])
    .map((p) => ({ ...p, lat: Number(p.lat), lng: Number(p.lng) }))
    .filter((p) => Number.isFinite(p.lat) && Number.isFinite(p.lng))
    .reverse(), [block?.items]);
  const stats = block?.stats || [];
  const [selected, setSelected] = useState(0);

  return (
    <section id="ubicaciones" className="section-elev py-20 md:py-32 relative overflow-hidden">
      <div className="max-w-[1300px] mx-auto px-5 sm:px-6 lg:px-10 relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-8 md:mb-10">
          <div>
            <Reveal><span className="eyebrow">{block?.eyebrow || "Presencia nacional"}</span></Reveal>
            <Reveal delay={120}>
              <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-[#0A0A0A] max-w-3xl leading-[1.02]">
                {renderTitle(block?.title || "No estamos proyectando desde cero. <em>Ya sabemos</em> abrir y operar.")}
              </h2>
            </Reveal>
            <Reveal delay={220}>
              <p className="mt-5 text-[#3F3F46] text-base md:text-lg max-w-2xl leading-relaxed">
                {block?.subtitle || "Explora la presencia actual de Rubí Perfumería y conoce cómo la marca continúa identificando nuevas oportunidades de expansión."}
              </p>
            </Reveal>
          </div>
          {stats.length > 0 && (
            <Reveal delay={280}>
              <div className="flex flex-wrap gap-3">
                {stats.map((s, i) => (
                  <div key={i} className="glass px-5 py-3 rounded-2xl">
                    <div className="text-2xl num-mono text-[#0A0A0A]"><AnimatedCounter value={s.n} duration={900} /></div>
                    <div className="text-[10px] uppercase tracking-widest text-[#52525B] font-mono mt-0.5">{s.l}</div>
                  </div>
                ))}
              </div>
            </Reveal>
          )}
        </div>

        <Reveal delay={200} scale>
          <div className="glass-elev p-2 md:p-3 rounded-3xl">
            <Suspense fallback={<div className="h-[380px] md:h-[520px] rounded-2xl bg-[#0A0A0C] flex items-center justify-center text-[#52525B] text-sm font-mono">Cargando mapa…</div>}>
              <LocationsMap items={items} selected={selected} onSelect={setSelected} className="h-[380px] md:h-[520px]" />
            </Suspense>
            {block?.microcopy && (
              <div className="text-[10px] md:text-[11px] text-[#52525B] mt-4 text-center font-mono uppercase tracking-widest px-4 pb-2">
                {block.microcopy}
              </div>
            )}
          </div>
        </Reveal>

        {items.length > 0 && (
          <Reveal delay={300}>
            <LocationsCarousel items={items} selected={selected} onSelect={setSelected} />
          </Reveal>
        )}
      </div>
    </section>
  );
}
